import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  assetDataService
} from 'app/services';
import {
  confirmDialog,
  actionIcon,
  alerts
} from 'app/components/global';
import controller from './itAsset.controller';
import directive from './ITAsset.directive';

export default angular.module('app.components.advisory.enterpriseModeling.itAsset', [
  actionIcon,
  confirmDialog,
  ssDialogService,
  loaderService,
  alerts,
  assetDataService,
])
  .directive('emItAsset', directive)
  .controller('ITAssetController', controller)
  .name;

console.log('app.components.advisory.enterpriseModeling.itAsset created');
